import { h } from 'preact';
import cx from 'classnames';
import style from './style';
import WeatherSVGIcon from '../weather-svg-icon/';
import { Text } from 'preact-i18n';

let todayOrTonight = () => {
	let curTime = new Date();
	curTime = parseInt(curTime.getHours(), 10);
	if (curTime >= 19) {
		return <Text id="tonight" />;
	}
	return <Text id="today" />;

};

/**
 * Render the Forecast component
 * @param  {Array} {forecasts} Contains 0 or more objects with forecast data
 */
const Forecast = ({ forecasts, unit }) => {
	let hiTempSelector = unit === 'C' ? 'maxTempCels' : 'maxTemp';
	let loTempSelector = unit === 'C' ? 'minTempCels' : 'minTemp';
	return (
		<div class={style.forecast}>
			<div class={style.forecast__icons}>
				{ forecasts.map( forecast => (
					<div class={style.day}>
						<p class={style.dow}>
							{forecast.dowDisplay && (
								forecast.isForecastToday
									? todayOrTonight()
									: forecast.dowDisplay.slice(0, 3)
							)}
						</p>
						<div class={style.icons}>
							<WeatherSVGIcon name={forecast.weatherIconCode} class={cx(style.conditionIcon)} />
						</div>
						<p class={style['hi-lo']}>
							<span>{forecast[hiTempSelector]}°</span>
							<span class={style['min-degrees']}>{forecast[loTempSelector]}°</span>
						</p>
					</div>
				)) }
			</div>
		</div>
	);
};
export default Forecast;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/components/forecast/index.js